export enum TypeMerchantUserEnum {
    StoreEmployees = 1,
    WebAdmins = 2
}
